// @flow
import React from "react"

import FullPageMessage from "../FullPageMessage/FullPageMessage"
import translate from "../../../../app/scripts/tools/translate"

const MaintenanceModal = () => (
  <FullPageMessage
    imgSrc="/images/illust/maintenance.svg"
    header={translate("support.maintenance.header")}
    text={translate("support.maintenance.text")}
  />
)

export default MaintenanceModal
